import { createAction, props } from '@ngrx/store'

export const setMevo = createAction(
	'[Mevo] Set Mevo',
	props<{ value: boolean }>()
)

export const setMevoId = createAction('[Mevo] Set id', props<{ id: string }>())
